import { render, staticRenderFns } from "./SubscriptionOrderOrganisations.vue?vue&type=template&id=15f18cf0&"
import script from "./SubscriptionOrderOrganisations.vue?vue&type=script&lang=ts&"
export * from "./SubscriptionOrderOrganisations.vue?vue&type=script&lang=ts&"
import style0 from "./SubscriptionOrderOrganisations.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports